<template>
    <div v-if="show" class="flex items-center justify-center"
        :class="fullPage ? 'fixed inset-0 z-50 bg-black/30' : 'w-full h-full'">
        <div class="flex flex-col items-center gap-2 text-current">
            <svg class="animate-spin h-8 w-8" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
                <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>

            <span v-if="text" class="text-sm opacity-80">
                {{ text }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingContent',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        fullPage: {
            type: Boolean,
            default: true,
        },
        text: {
            type: String,
            default: 'loading...',
        },
    }
}
</script>
